import { useI18n } from "@/i18n";

export default function Marquee() {
  const { t } = useI18n();
  return (
    <div className="overflow-hidden border-y border-line bg-panel py-5" data-testid="marquee-ribbon">
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
            {t.marquee.map((item, i) => (
              <span key={i} className="flex items-center whitespace-nowrap text-xs font-medium tracking-[0.3em] text-zinc-400">
                <span className="mx-8 transition-colors duration-200 hover:text-white">{item}</span>
                <span className="text-gold">//</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
